/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-09-13 10:02:58
 * @LastEditors: caiqin.xie
 * @message: 搜索结果页-搜索列表
 */
import React from "react";
import ResultItem from "../ResultItem";
import styles from "../../index.module.scss";

interface IList {
  id: string;
  title: string; // 标题
  briefIntroduction: string; // 简介
  dataType: number; // 数据类型 1-内容 2-门店 3-产品
  contentTypeId: string; // 内容类型id
  seoUrl: string; // 地址栏显示名称
  [key: string]: any;
}
interface IProps {
  ctry: string;
  device: string;
  resultList: IList[]; // 搜索结果
  allList: IList[]; // 全部结果
}
const ResultList = (props:IProps) => {
  const {ctry, device, resultList, allList} = props
  const list = device === 'pc' ? resultList : allList

  return (
    <div className={styles['result-list']}>
      {list && list.map((item, index) => (
        <ResultItem ctry={ctry} item={item} key={item.id} />
      ))}
    </div>
  )
}
export default ResultList
